import "@/App.css";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useLenis } from "@/hooks/useLenis";
import { scrollTop } from "@/lib/scroll";
import Home from "@/pages/Home";
import About from "@/pages/About";
import BrandProfile from "@/pages/BrandProfile";
import Admin from "@/pages/Admin";
import LegalDoc from "@/pages/LegalDoc";
import Insights from "@/pages/Insights";
import Healthcare from "@/pages/Healthcare";
import CountryPage from "@/pages/CountryPage";
import PatientSupport from "@/pages/PatientSupport";
import PatientJourney from "@/pages/PatientJourney";
import HealthcarePartnerships from "@/pages/HealthcarePartnerships";
import Trading from "@/pages/Trading";
import VietnamSourcing from "@/pages/VietnamSourcing";
import SourcingProducts from "@/pages/SourcingProducts";
import FindSuppliers from "@/pages/FindSuppliers";
import ProductPage from "@/pages/ProductPage";
import Buyers from "@/pages/Buyers";
import Suppliers from "@/pages/Suppliers";
import TradingProcess from "@/pages/TradingProcess";
import Compliance from "@/pages/Compliance";
import MauritiusPage from "@/pages/MauritiusPage";
import GlobalNetwork from "@/pages/GlobalNetwork";
import OurBrands from "@/pages/OurBrands";
import Contact from "@/pages/Contact";
import HealthcareEnquiry from "@/pages/HealthcareEnquiry";
import TradingEnquiry from "@/pages/TradingEnquiry";
import SourcingEnquiry from "@/pages/SourcingEnquiry";
import PartnershipEnquiry from "@/pages/PartnershipEnquiry";

function ScrollReset() {
    const { pathname } = useLocation();
    useEffect(() => {
        scrollTop();
    }, [pathname]);
    return null;
}

function App() {
    useLenis();

    return (
        <HelmetProvider>
        <div className="App">
            <BrowserRouter>
                <ScrollReset />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/mauritius" element={<MauritiusPage />} />
                    <Route path="/our-brands" element={<OurBrands />} />
                    <Route path="/global-network" element={<GlobalNetwork />} />
                    <Route path="/insights" element={<Insights />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/healthcare-medical-tourism" element={<Healthcare />} />
                    <Route path="/medical-tourism-vietnam" element={<CountryPage cid="vietnam" />} />
                    <Route path="/medical-tourism-india" element={<CountryPage cid="india" />} />
                    <Route path="/medical-tourism-thailand" element={<CountryPage cid="thailand" />} />
                    <Route path="/medical-tourism-china" element={<CountryPage cid="china" />} />
                    <Route path="/patient-support" element={<PatientSupport />} />
                    <Route path="/patient-journey" element={<PatientJourney />} />
                    <Route path="/healthcare-partnerships" element={<HealthcarePartnerships />} />
                    <Route path="/healthcare-enquiry" element={<HealthcareEnquiry />} />
                    <Route path="/international-trading" element={<Trading />} />
                    <Route path="/vietnam-sourcing-agent" element={<VietnamSourcing />} />
                    <Route path="/sourcing-products-from-vietnam" element={<SourcingProducts />} />
                    <Route path="/find-suppliers-in-vietnam" element={<FindSuppliers />} />
                    <Route path="/vietnam-sourcing-enquiry" element={<SourcingEnquiry />} />
                    <Route path="/rice-export-from-vietnam" element={<ProductPage pid="rice-vietnam" />} />
                    <Route path="/seafood-suppliers-vietnam" element={<ProductPage pid="seafood-vietnam" />} />
                    <Route path="/dry-fruits-agricultural-products-vietnam" element={<ProductPage pid="dry-fruits-vietnam" />} />
                    <Route path="/oil-gas-products" element={<ProductPage pid="oil-gas" />} />
                    <Route path="/buyers" element={<Buyers />} />
                    <Route path="/suppliers" element={<Suppliers />} />
                    <Route path="/trading-process" element={<TradingProcess />} />
                    <Route path="/compliance-due-diligence" element={<Compliance />} />
                    <Route path="/trading-enquiry" element={<TradingEnquiry />} />
                    <Route path="/partnership-enquiry" element={<PartnershipEnquiry />} />
                    <Route path="/brands/:brandId" element={<BrandProfile />} />
                    <Route path="/legal/:docId" element={<LegalDoc />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="top-center"
                toastOptions={{
                    style: {
                        background: "#0B172A",
                        border: "1px solid rgba(197, 160, 89, 0.35)",
                        color: "#FAF9F5",
                        borderRadius: "2px",
                    },
                }}
            />
        </div>
        </HelmetProvider>
    );
}

export default App;
